module.exports = __webpack_public_path__ + "static/media/DSC_0035.f3cb0051.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/people/DSC_0035.jpg
// module id = 619
// module chunks = 0